import { render, staticRenderFns } from "./BalanceDetail.vue?vue&type=template&id=6b58d632&scoped=true&"
import script from "./BalanceDetail.vue?vue&type=script&lang=ts&"
export * from "./BalanceDetail.vue?vue&type=script&lang=ts&"
import style0 from "./BalanceDetail.vue?vue&type=style&index=0&id=6b58d632&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b58d632",
  null
  
)

export default component.exports